import { motion } from 'framer-motion';
import { insidePages } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function InsideSection() {
  return <section className="bg-crudo px-5 py-14 text-noche sm:px-8 lg:py-18" data-id="element-82" data-mp="1kc5srbmhfj7">
      <div className="mx-auto max-w-6xl" data-id="element-83" data-mp="3jybo7nrrfx54">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="max-w-2xl" data-id="element-84" data-mp="3jxaatcn9uyk8">
          <h2 className="font-display text-2xl font-black uppercase leading-tight sm:text-3xl lg:text-4xl" data-id="element-85" data-mp="3f0tc5oig51sw">
            Material para llevar
            <span className="block text-electrico" data-id="element-86" data-mp="312lm80jtv0r8">
              lo aprendido a la práctica
            </span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-noche/60 sm:text-base" data-id="element-87" data-mp="z8clptthig9w">
            Mirá ejemplos reales del contenido que vas a recibir.
          </p>
        </motion.div>
      </div>

      {/* Horizontal scroller — reads as a gallery on mobile without stacking */}
      <motion.ul initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.4,
      delay: 0.05,
      ease: EASE
    }} className="mt-8 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-3 sm:gap-4 sm:px-8 lg:mx-auto lg:max-w-6xl lg:px-0" style={{
      scrollbarWidth: 'thin'
    }} data-id="element-88" data-mp="2vugcsjqiqren">
        {insidePages.map(page => <li key={page.caption} className="w-[72%] shrink-0 snap-start overflow-hidden rounded-2xl border border-aluminio bg-white sm:w-[44%] lg:w-[30%]" data-id="element-89" data-mp="2cwnlkep9c5x3">
            <img src={page.image} alt={page.alt} className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-90" data-mp="2lw0v17ddsuht" />
            <p className="px-4 py-3 font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-electrico sm:text-xs" data-id="element-91" data-mp="16bhcxoezeqp">
              {page.caption}
            </p>
          </li>)}
      </motion.ul>
    </section>;
}